import { render, staticRenderFns } from "./PurchasesDelayed.vue?vue&type=template&id=0bdf3634&scoped=true&"
import script from "./PurchasesDelayed.vue?vue&type=script&lang=js&"
export * from "./PurchasesDelayed.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesDelayed.vue?vue&type=style&index=0&id=0bdf3634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf3634",
  null
  
)

export default component.exports